import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DefaultCard from '../../../components/default/DefaultCard';
import LazyLoading from '../../../components/LazyLoading';
import useQuoteService from '../../../app/services/hooks/useQuoteService';
import { QuoteShowDataForm } from '../../../app/models/Quote';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useNavigationPage from '../../../hooks/useNavigationPage';
import { QuoteRouteSegment } from '../../../app/models/QuoteRouteSegment';
import QuoteShowContainer from '../components/containers/QuoteShowContainer';
import WareHouseQuoteShowContainer from '../components/containers/WareHouseQuoteShowContainer';
import { SectorBusinessRulesEnum } from '../../../app/shared/enums';
import useQuoteInvoicingService from '../../../app/services/hooks/useQuoteInvoicingService';
import { QuoteInvoicingShowDataForm } from '../../../app/models/QuoteInvoicing';

const QuoteShow = () => {
  const { navigationPage } = useNavigationPage();
  const { id } = useParams<{ id: string }>();
  const [verifyingQuote, setVerifyingQuote] = useState(true);
  const { showQuote, fetchingShowQuote } = useQuoteService();

  const [quoteForm, setQuoteForm] = useState<QuoteShowDataForm>({
    client: '',
    created_at: '',
    created_user: '',
    currency: '',
    id: 0,
    last_modified_user: '',
    payment_condition: '',
    payment_method: '',
    quote_details: [],
    society: '',
    status: '',
    status_selected: { id: '', name: '' },
    status_choices: [],
    updated_at: '',
    contact_email: '',
    expired_in_days: 0,
    comment: ''
  });

  const [quoteRouteSegments, setQuoteRouteSegments] = useState<QuoteRouteSegment[]>([]);
  const [quoteCheckDocument, setQuoteCheckDocument] = useState(false);
  const [warehouseStorage, setWarehouseStorage] = useState([]);
  const [warehouseExpedition, setWarehouseExpedition] = useState([]);
  const [warehouseQuoteDetail, setWarehouseQuoteDetail] = useState({});
  const [sectorId, setSectorId] = useState(0);
    const { 
        getQuoteInvoicingByQuote,
        updateQuoteInvoicing, 
        fetchingQuoteInvoicingByQuote,
        fetchingUpdateQuoteInvoicing
    } = useQuoteInvoicingService();
  useEffect(() => {
    show(parseInt(id));
  }, [id]);

  const show = (id: number) => {
    showQuote(id, {
      onSuccess: (response: ServiceResponse) => {
        const quote = response.data.quote;
        if (quote.days_count && quote.days_count > 0) {
          quote.reference = '';
          quote.days_count = 0;
        }

        setQuoteForm(quote);
        setQuoteCheckDocument(quote.is_route_segment_document);
        setQuoteRouteSegments(response.data.quote_route_segments || []);
        setSectorId(response.data.quote.sector_id)

        if (quote.sector_business_rules_enum === SectorBusinessRulesEnum.WHS_Almacenamiento) {
          setWarehouseQuoteDetail(response.data.warehouse_quote_detail ?? {});
          setWarehouseStorage(response.data.storage ?? []);
          setWarehouseExpedition(response.data.expedition ?? []);
        }

        setVerifyingQuote(false);
      },
      onError: (response: ServiceResponse) => {
        toast.error(response.message);
        navigationPage('/quotes');
      }
    });
  };

  const [quoteInvoicingForm, setQuoteInvoicingForm] = useState<QuoteInvoicingShowDataForm>({
  
    });
  const reloadQuoteInvoicing = (id: number) => {
  
          if (id) {
              getQuoteInvoicingByQuote(Number(id),'view', {
                  onSuccess: (response: ServiceResponse) => {
                      setQuoteInvoicingForm(response.data.quote_invoicing);
                  },
                  onError: (response: ServiceResponse) => 
                      {
                      toast.info(response.message);
                  }
              });
          }
      };
    
  if (verifyingQuote) {
    return (
      <DefaultCard>
        <LazyLoading height={300} />
      </DefaultCard>
    );
  }

  if (quoteForm.sector_business_rules_enum === SectorBusinessRulesEnum.WHS_Almacenamiento) {
    return (
      <WareHouseQuoteShowContainer
        id={parseInt(id)}
        sectorId={sectorId}
        quoteForm={quoteForm}
        disableUpdate={true}
      />
    );
  }

  return (
    <QuoteShowContainer
      id={parseInt(id)}
      quoteForm={quoteForm}
      quoteRouteSegments={quoteRouteSegments}
      quoteCheckDocument={quoteCheckDocument}
      fetchingQuote={fetchingShowQuote}
      setQuoteRouteSegments={setQuoteRouteSegments}
    />
  );
};

export default QuoteShow;